<template>
    <LocalDetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :task_table_headers="task_table_headers"
        :tasks="tasks"
        :back_href="'/building-room-types'"
    />    
</template>

<script>

import FormResources            from  './form_resources'
import Resources                from  './resources'
import LocalDetailComponent     from  './LocalDetailComponent'
import { Notyf }                from  'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'RoomTypeDetail',
    components: {
        LocalDetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            task_table_headers: Resources.task_table_headers,
            rest_api:           `room_types/${this.$route.params.id}`,
            rest_api_note:      `room_type_notes`,
            form_format:        FormResources.form_format,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            tasks:              [],
            single_object:      {},
            array_options:      {},
        }
    },

    watch: {

        "single_object.unit"(val)
        {
            if(val < 1 || val > 6)
            {
                this.single_object.unit = 1
            }
        }

    },

    methods:{

        fill_data(data)
        {
            this.single_object  = data.room_type

            this.array_options  = {
                floor_id: data.floors
            }

            this.title_page     = this.single_object.name

            this.tasks = data.tasks

            if(this.tasks.length)
            {
                this.tasks.forEach((item, i) =>
                {
                    window.$(`#select${i}`).prop('checked', false)
                    item['checked']   = false
                    item['frequency'] = ''
                    item['order']     = ''
                })

                if(this.single_object.tasks.length)
                {
                    this.single_object.tasks.forEach((item) => {
                        let arrIndex = this.tasks.findIndex(prop => prop.id === item.task_id)
                        if(arrIndex > -1)
                        {
                            this.tasks[arrIndex].checked   = true
                            this.tasks[arrIndex].frequency = item.frequency
                            this.tasks[arrIndex].order     = item.order
                            window.$(`#selectAlt${arrIndex}`).prop('checked', true)
                        }
                    })
                }
            }

            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.description,
                href:   `/building-room-types/${this.parent_id}`,
                arrow:  '',
            })
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['Building-Room-Type Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    }
}
</script>